import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useGeneralStore } from "%/stores/general-store";

export const useCourseFeedStore = defineSmartFeedPiniaStore(
  "course-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        publicationId: {
          key: "publication_id",
          payload: useCreatorPublicationStore().publicationId,
        },
        orgId: {
          key: "org_id",
          payload: useGeneralStore().orgId,
        },
      },
      tableFields: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "price",
          label: "Price",
        },
        {
          key: "numberOfLessons",
          label: "Number of Lessons",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "actions",
          label: "",
        },
      ],
    }),
    getters: {
      feedUrl() {
        return `/courses/${useCreatorPublicationStore().publicationId}`;
      },
    },
  },
);
